import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-modification-courriel',
  templateUrl: './modification-courriel.component.html',
  standalone: false,
})
export class ModificationCourrielComponent {
  @Input() formGroup!: FormGroup;
  @Input() required: boolean = true;
  @Input() maxLength: number;
}
